import { ICheckoutCart, ICheckoutCartOffer, ICheckoutCartOfferPrice } from '@/interfaces/Checkout';

import { Purchase } from './Purchase';

export class UpsellPurchase extends Purchase {
  upsell_id: number;

  constructor(selectedOfferPrice: ICheckoutCartOfferPrice, selectedOffer: ICheckoutCartOffer, rootOffer: ICheckoutCartOffer, cartId: string, upsell_id: number) {
    super(selectedOfferPrice, selectedOffer, rootOffer, cartId);
    this.upsell_id = upsell_id;
  }
}
